<template>
  <div class="col">
    <div class="row confirm-email align-items-center">
      <img src="@/assets/static/confirmEmail/lock.svg" class="confirm-email__img"/>
      <span class="confirm-email__text">Please, confirm your email ({{this.$store.state.account.email}})</span>
      <div v-if="showResendButton" class="resend-email row align-items-center">
        <img src="@/assets/static/confirmEmail/link.svg" class="resend-email__img"/>
        <span @click="resendConfirmationMail" class="resend-email__text" type="button">Resend confirmation email</span>
      </div>
    </div>
  </div>
</template>

<script>
  import { resendConfirmationMailMixin } from '../../mixins/resendConfirmationMailMixin';

  export default {
    name: 'ConfirmEmailNotification',
    mixins: [resendConfirmationMailMixin],
  };
</script>

<style scoped>
  .confirm-email {
    position: fixed;
    background-color: #2EA763;
    border-radius: 4px 4px 0 0;
    padding: 10px;
    left: 30%;
    width: 40%;
    height: 7%;
    bottom: 0;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.25);
  }
  .confirm-email__text {
    color: white;
    font-size: 16px;
    margin-left: 19px;
  }
  .confirm-email__img {
    height: 20px;
    margin-left: 20px;
  }

  .resend-email {
    padding: 4px;
    border-radius: 5px;
    margin-left: 20px;
    background-color: white;
  }
  .resend-email__img {
    height: 12px; margin-left: 5px;
  }
  .resend-email__text {
    font-size: 12px;
    margin-left: 5px;
  }
</style>
